import './style/modal-show-loading.css';
import styled from '@emotion/styled';
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import App from './App';
import Spinners from './childcomp/spinners/Spinners';
import { Provider } from 'react-redux';
import store from './redux/store';

const ModalContent = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    opacity: 0.5;
    padding: 1rem 1.5rem;
    width: auto;
    border-radius: 0.5rem;
`;

ReactDOM.render(
    <>
        <Provider store={store}>
            <App />
        </Provider>
        <div id="Modal-show-loading-data-api-call" className="Modal-show-loading-data-modal">
            <ModalContent>
                <Spinners />
            </ModalContent>
        </div>
    </>,
    document.getElementById('root')
);
reportWebVitals();